import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { BrandingAssets } from "@/features/settings/components/branding-assets"
import { BrandingColour } from "@/features/settings/components/branding-colour"
import { BrandingIdentity } from "@/features/settings/components/branding-identity"
import { PageContent } from "@/components/common/page-content"
import { organisationQueries } from "@/queries/organisations"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/branding/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(organisationQueries.current()),
  component: BrandingSettingsPage,
})

function BrandingSettingsPage() {
  const { data: organisation } = useSuspenseQuery(organisationQueries.current())

  return (
    <>
      <PageHeader title="Branding" />
      <PageContent>
        <BrandingIdentity organisation={organisation} />
        <BrandingColour organisation={organisation} />
        <BrandingAssets organisation={organisation} />
      </PageContent>
    </>
  )
}
